import script from "./tool-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./tool-dialog.vue?vue&type=script&setup=true&lang=js"

import "./tool-dialog.vue?vue&type=style&index=0&id=5c6f5ae1&lang=scss"

const __exports__ = script;

export default __exports__